module.exports = __webpack_public_path__ + "img/20190928142547389.dbaab754.jpg";